import { Box, Chip, TableCell, TableContainer, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Row } from '../Profile/profile-styles'

// Each admin section renders as its own card, matching the settings page's
// ContentCard chrome (the shared Section is a bare box on purpose).
export const SectionCard = styled(Box)(({ theme }) => ({
    padding: theme.spacing(4),
    borderRadius: Number(theme.shape.borderRadius) * 2,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[1],
}))

// Overview stat cards
export const StatCardsRow = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
}))

export const StatCardBox = styled(Box)(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: Number(theme.shape.borderRadius) * 2,
    padding: theme.spacing(2),
    minWidth: 140,
    flex: '1 1 140px',
}))

export const TestPushRow = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(2),
    display: 'flex',
    gap: 8
}))

// Email opt-in rows
export const OptInHeaderRow = styled(Row)({
    cursor: 'pointer',
})

export const OptInCountBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
}))

export const OptInListBox = styled(Box)(({ theme }) => ({
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(1.5),
}))

// Users table
export const AdminBadgeChip = styled(Chip)(({ theme }) => ({
    marginLeft: theme.spacing(1),
}))

export const FlagChipStyled = styled(Chip)(({ theme }) => ({
    marginRight: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
}))

// Collapsible details cell: the border only shows while the row is expanded.
export const CollapsibleCell = styled(TableCell, {
    shouldForwardProp: (prop) => prop !== 'open',
})<{ open: boolean }>(({ open }) => ({
    paddingTop: 0,
    paddingBottom: 0,
    ...(open ? {} : { borderBottom: 'none' }),
}))

export const UserDetailsBox = styled(Box)(({ theme }) => ({
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
}))

export const UserMetaText = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(1),
}))

export const UserActionsRow = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
    marginTop: theme.spacing(1.5),
}))

export const ScrollableTableContainer = styled(TableContainer)({
    overflowX: 'auto',
})

// Most tracked
export const MostTrackedColumns = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(4),
}))

export const MostTrackedColumn = styled(Box)({
    minWidth: 220,
    flex: '1 1 220px',
})

export const MostTrackedHeading = styled(Typography)(({ theme }) => ({
    fontWeight: 600,
    marginBottom: theme.spacing(1),
}))

export const MostTrackedRow = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    paddingTop: theme.spacing(0.25),
    paddingBottom: theme.spacing(0.25),
}))

// Rendered as a real router link (component={RouterLink}) so right-click works
export const MostTrackedTitleLink = styled(Typography)<{ component?: React.ElementType; to?: string }>({
    fontSize: 14,
    color: 'inherit',
    textDecoration: 'none',
    '&:hover': {
        textDecoration: 'underline',
    },
})

export const CommentMediaLink = styled(Typography)<{ component?: React.ElementType; to?: string }>(({ theme }) => ({
    fontSize: 13,
    color: 'inherit',
    textDecoration: 'none',
    '&:hover': {
        textDecoration: 'underline',
        color: theme.palette.brand.main
    },
}))

// Users table: name opens the account's public profile page.
export const UserNameLink = styled(Typography)<{ component?: React.ElementType; to?: string }>(({ theme }) => ({
    fontSize: 'inherit',
    color: 'inherit',
    textDecoration: 'none',
    display: 'inline',
    '&:hover': {
        textDecoration: 'underline',
        color: theme.palette.brand.main,
    },
}))

// Recent comments
export const CommentRow = styled(Box)(({ theme }) => ({
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
}))

export const CommentBody = styled(Box)({
    minWidth: 0,
})

export const CommentContent = styled(Typography)({
    fontSize: 14,
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
})

export const CommentActions = styled(Box)({
    flexShrink: 0,
})
